<app-spinner></app-spinner>
<div class="container-fluid">
    <div class="shadow-wrapper my-3 mx-2 mx-sm-3">
        
        <!-- Header -->
        <div class="row py-2">
            <div class="col-12">
                <h3 class="dashboard">
                    {{ translation.t('preview','ticketId') }} : {{prevViewFileObj['ticket_id']}}
                </h3>
            </div>
        </div>

        <!-- Back Button -->
        <div class="row py-1">
            <div class="col-12 d-flex justify-content-end">
                <h4 class="dashboard cursor-pointer hover-blue" style="color: rgb(24, 107, 202);" 
                    (click)="back()" role="button">
                    ← {{ translation.t('common','back') }}
                </h4>
            </div>
        </div>

        <!-- Status -->
        <div class="row py-1 mb-3">
            <div class="col-12 d-flex justify-content-end align-items-center">
                <h6>
                    {{ translation.t('common','status') }} : 
                    <strong>{{prevViewFileObj['status']}}</strong>
                </h6>
            </div>
        </div>

        <!-- Main Details -->
        <div class="row py-1 mb-3">
            <div class="col-md-6 mb-3">
                <div class="d-flex">
                    <div class="label-col">
                        <h6>{{ translation.t('preview','fullName') }}</h6>
                    </div>
                    <div class="separator-col">:</div>
                    <div class="value-col">
                        {{prevViewFileObj['full_name']}}
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="d-flex">
                    <div class="label-col">
                        <h6>{{ translation.t('preview','mobileNo') }}</h6>
                    </div>
                    <div class="separator-col">:</div>
                    <div class="value-col">
                        {{prevViewFileObj['mobile_no']}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row py-1 mb-3">
            <div class="col-md-6 mb-3">
                <div class="d-flex">
                    <div class="label-col">
                        <h6>{{ translation.t('preview','complaintDepartment') }}</h6>
                    </div>
                    <div class="separator-col">:</div>
                    <div class="value-col">
                        {{prevViewFileObj['departments']}}
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="d-flex">
                    <div class="label-col">
                        <h6>{{ translation.t('preview','zone') }}</h6>
                    </div>
                    <div class="separator-col">:</div>
                    <div class="value-col">
                        {{prevViewFileObj['zone']}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row py-1 mb-3">
            <div class="col-12">
                <div class="d-flex">
                    <div class="label-col">
                        <h6>{{ translation.t('preview','ward') }}</h6>
                    </div>
                    <div class="separator-col">:</div>
                    <div class="value-col">
                        {{prevViewFileObj['ward']}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row py-1 mb-3">
    <div class="col-12">
<div class="d-flex flex-column flex-sm-row">            
            <div class="d-flex align-items-start">   <!-- Label + Colon in one line -->
                <div class="label-col">
                    <h6>{{ translation.t('preview','complaintDescription') }}</h6>
                </div>
                <div class="separator-col">:</div>
            </div>

            <div class="value-col mt-1">   <!-- Value on next line with a little gap -->
                {{prevViewFileObj['complaint_desc']}}
            </div>

        </div>
    </div>
</div>

        <!-- Uploaded Document -->
        <div class="row py-1 mb-3">
            <div class="col-12">
                <div class="d-flex flex-column flex-sm-row align-items-sm-center">
                    <div class="label-col">
                        <h6>{{ translation.t('preview','uploadedDocument') }}</h6>
                    </div>
                    <div class="separator-col d-none d-sm-block">:</div>
                    <div class="value-col mt-1 mt-sm-0">
                        <div *ngIf="prevViewFileObj['com_doc'] !== 'N/A' || (prevViewFileObj['others_doc'] == 'N/A' &&  ['CLOSED','RESOLVED'].includes(prevViewFileObj['status'])); else com_doc"
                            [ngClass]="prevViewFileObj['com_doc'] === 'N/A' ? 'black-underline' : 'green-underline'"
                            class="cursor-pointer d-inline-block" role="button" 
                            (click)="viewDoc(prevViewFileObj, 'com_doc', 'com')">
                            {{ prevViewFileObj['com_doc'] }}
                        </div>

                        <ng-template #com_doc>
                            <div class="d-flex flex-wrap gap-2">
                                <input type="file" (change)="checkFile($event, 'com')" class="upload" />
                                <button class="btn btn-sm btn-primary upload-btn" 
                                    [disabled]="!selectedFileUrlObj?.com?.file_name"
                                    (click)="upload('com')">
                                    {{ translation.t('common','upload') }}
                                </button>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>

        <!-- Other Document -->
        <div class="row py-1 mb-4">
            <div class="col-12">
                <div class="d-flex flex-column flex-sm-row align-items-sm-center">
                    <div class="label-col">
                        <h6>{{ translation.t('preview','otherDocument') }}</h6>
                    </div>
                    <div class="separator-col d-none d-sm-block">:</div>
                    <div class="value-col mt-1 mt-sm-0">
                        <div *ngIf="prevViewFileObj['others_doc'] !== 'N/A' || (prevViewFileObj['others_doc'] == 'N/A' &&  ['CLOSED','RESOLVED'].includes(prevViewFileObj['status'])); else others_doc"
                            [ngClass]="prevViewFileObj['others_doc'] === 'N/A' ? 'black-underline' : 'green-underline'"
                            class="cursor-pointer d-inline-block" role="button" 
                            (click)="viewDoc(prevViewFileObj, 'others_doc', 'others')">
                            {{ prevViewFileObj['others_doc'] }}
                        </div>

                        <ng-template #others_doc>
                            <div class="d-flex flex-wrap gap-2">
                                <input type="file" (change)="checkFile($event, 'others')" class="upload" />
                                <button class="btn btn-sm btn-primary upload-btn" 
                                    [disabled]="!selectedFileUrlObj?.others?.file_name"
                                    (click)="upload('others')">
                                    {{ translation.t('common','upload') }}
                                </button>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>

        <!-- Instant Resolution Details -->
        <div class="my-4">
            <h5 class="font-bold fs-5">{{ translation.t('preview','instantResolutionDetails') }}</h5>
        </div>

        <div class="row py-1 mb-3" *ngIf="prevViewFileObj['is_instant_resolved']; else IsInstant">
            <!-- Instant Resolved Content (same as before) -->
            <div class="col-12">
                <div class="d-flex">
                    <div class="label-col"><h6>{{ translation.t('preview','isInstantResolved') }}</h6></div>
                    <div class="separator-col">:</div>
                    <div class="value-col">{{ translation.t('common','yes') }}</div>
                </div>
            </div>
            <!-- Repeat similar d-flex pattern for remark, approval_desc, and resolved_doc -->
            <!-- ... (you can keep the existing structure or apply same d-flex pattern) -->
        </div>

        <ng-template #IsInstant>
            <div class="row py-1 mb-3">
                <div class="col-12">
                    <div class="d-flex">
                        <div class="label-col"><h6>{{ translation.t('preview','isInstantResolved') }}</h6></div>
                        <div class="separator-col">:</div>
                        <div class="value-col">{{ translation.t('common','no') }}</div>
                    </div>
                </div>
            </div>
        </ng-template>

        <!-- Logs / History Section -->
        <div class="row py-1 mb-4">
            <div class="col-12 mb-3">
                <h5 class="font-bold fs-5">{{ translation.t('preview','othersDetails') }}</h5>
            </div>
            
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>{{ translation.t('common','status') }}</th>
                            <th>{{ translation.t('preview','name') }}</th>
                            <th>{{ translation.t('preview','date') }}</th>
                            <th>{{ translation.t('preview','document') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let obj of logs">
                            <td>
                                {{ obj['status'] === 'REGISTERED' ? translation.t('preview','registeredBy') : 
                                  obj['status'] === 'PENDING' ? translation.t('preview','pendingAt') :
                                  obj['status'] === 'CLOSED' ? translation.t('preview','closedBy') : 
                                  obj['status'] === 'RESOLVED' ? translation.t('preview','resolvedBy') : 'N/A' }}
                            </td>
                            <td>{{obj['user_name']}}</td>
                            <td>{{ obj['status'] === 'CLOSED' ? obj['created_date'] : 
                                  obj['status'] === 'RESOLVED' ? obj['updated_date'] : obj['created_date'] || 'N/A' }}</td>
                            <td>
                                <div *ngIf="obj['upload_doc']=='N/A'; else upload_doc_template" class="text-muted">
                                    {{obj['upload_doc']}}
                                </div>
                                <ng-template #upload_doc_template>
                                    <div [ngClass]="obj['upload_doc'] === 'N/A' ? 'black-underline' : 'green-underline'"
                                        class="cursor-pointer" role="button"
                                        (click)="viewDoc(obj, 'upload_doc', obj['status'] === 'RESOLVED'?'resolved':'closed')">
                                        {{ obj['upload_doc'] }}
                                    </div>
                                </ng-template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="row justify-content-end g-3 mt-4">
            <div class="col-12 col-sm-4 col-md-3" *ngIf="erpUser.role_cd.includes('Officer') && appr_flag">
                <h6 class="update-btn text-center py-3" (click)="route(prevViewFileObj)">
                    {{ translation.t('preview','update') }}
                </h6>
            </div>
            <div class="col-12 col-sm-4 col-md-3">
                <h6 class="print-btn text-center py-3" (click)="onDownloadPDF(prevViewFileObj);" 
                    [title]="translation.t('preview','printFormTitle')">
                    {{ translation.t('preview','printForm') }}
                </h6>
            </div>
        </div>

    </div>
</div>